import React, { useEffect } from 'react';
import { IGoogleAnalyticsProps } from './google-analytics.type';
import { GA_MEASUREMENT_ID } from '../../constants/platform';

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

/**
 * Nạp gtag.js cho mã đo GA_MEASUREMENT_ID.
 * Trước đây dùng <Helmet><script>…</script></Helmet> — tức script nội tuyến, bị CSP chặn khi bật
 * chế độ chặn thật. Giờ khởi tạo dataLayer/gtag bằng mã thường và chỉ chèn thẻ script có src
 * (www.googletagmanager.com đã có trong CSP). Gắn một lần cho cả trang dù nhiều layout cùng dùng.
 */
export const GoogleAnalytics: React.FC<IGoogleAnalyticsProps> = () => {
  useEffect(() => {
    if (!GA_MEASUREMENT_ID) return;
    const scriptId = `gtag-js-${GA_MEASUREMENT_ID}`;
    if (document.getElementById(scriptId)) return;

    window.dataLayer = window.dataLayer || [];
    // gtag chuẩn của Google: đẩy nguyên đối tượng arguments vào dataLayer.
    // eslint-disable-next-line prefer-rest-params
    const gtag = function gtag() { window.dataLayer.push(arguments); } as (...args: unknown[]) => void;
    if (!window.gtag) window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', GA_MEASUREMENT_ID);

    const script = document.createElement('script');
    script.id = scriptId;
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    document.head.appendChild(script);
  }, []);

  return null;
};
